<template>
  <div class="home-h5">
    <div class="home-h5-hero">
      <div class="home-h5-avatar">
        <img v-if="user.avatar" :src="user.avatar" alt="avatar"/>
        <i v-else class="el-icon-user"></i>
      </div>
      <div class="home-h5-info">
        <div class="home-h5-hello">{{ user.nick || user.name || '用户' }}</div>
        <div class="home-h5-sub">{{ user.role || '' }} · 欢迎使用语音识别系统</div>
      </div>
    </div>

    <div class="home-h5-grid">
      <div
          class="home-h5-grid-item"
          v-for="item in menus"
          :key="item.path"
          @click="$router.push(item.path)"
      >
        <i :class="item.icon" class="home-h5-grid-icon" :style="{background: item.color}"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>

    <div class="home-h5-tip">
      <i class="el-icon-info"></i>
      <span>提示：录音识别功能支持多任务连续录制，未上传的任务可在下次进入时继续。</span>
    </div>

    <H5Tabbar active="home"></H5Tabbar>
  </div>
</template>

<script>
import H5Tabbar from "./H5Tabbar.vue";

export default {
  name: "HomeH5",
  components: {H5Tabbar},
  data() {
    return {
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      menus: [
        {label: '语音识别', path: '/meeting_h5', icon: 'el-icon-microphone', color: '#409eff'},
        {label: '循环录音', path: '/meeting_h5_loop', icon: 'el-icon-refresh', color: '#8e44ad'},
        {label: '文件管理', path: '/document_h5', icon: 'el-icon-folder-opened', color: '#67c23a'},
        {label: '用户管理', path: '/user_h5', icon: 'el-icon-user', color: '#e6a23c'},
        {label: '角色管理', path: '/role_h5', icon: 'el-icon-user-solid', color: '#f56c6c'},
        {label: '个人中心', path: '/person_h5', icon: 'el-icon-s-custom', color: '#909399'},
      ]
    }
  }
}
</script>

<style scoped>
.home-h5 {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: 62px;
  box-sizing: border-box;
  max-width: 640px;
  margin: 0 auto;
  -webkit-tap-highlight-color: transparent;
}
.home-h5-hero {
  background: linear-gradient(135deg, #409eff, #2b6fd4);
  padding: 40px 20px 30px;
  display: flex;
  align-items: center;
  gap: 14px;
  color: #fff;
}
.home-h5-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 28px;
  flex-shrink: 0;
}
.home-h5-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home-h5-hello {
  font-size: 20px;
  font-weight: 700;
}
.home-h5-sub {
  margin-top: 6px;
  font-size: 13px;
  opacity: 0.9;
}
.home-h5-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 20px 16px;
}
.home-h5-grid-item {
  background: #fff;
  border-radius: 12px;
  padding: 18px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.06);
  font-size: 13px;
  color: #303133;
  transition: transform 0.15s;
}
.home-h5-grid-item:active {
  transform: scale(0.96);
}
.home-h5-grid-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  color: #fff;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-h5-tip {
  margin: 4px 16px 20px;
  padding: 12px;
  border-radius: 8px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  line-height: 1.6;
  display: flex;
  gap: 6px;
  align-items: flex-start;
}
.home-h5-tip .el-icon-info {
  margin-top: 2px;
}
</style>
